import { useAlert as useAlertHook } from "components/Alerts/hooks"
import { alerts } from "keys"
import { useDispatch } from "react-redux"
import { reset } from "redux-form"
import { actions } from "store"

const useAlert = () => {
    const dispatch = useDispatch()
    const { setAlerts } = useAlertHook()

    const handleCreateAffiliationAlert = (value) => {
        dispatch(actions.setAlerts({
            key: alerts.createAffliation,
            value: { open: value, props: null }
        }))
        if (!value)
            dispatch(reset("createAffliation"))
    }

    return handleCreateAffiliationAlert
}

export default useAlert